module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_1_1-6b54396ae49c4c2c44a5c444c502114e.png";